var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluetick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5804 8.19057C15.5804 12.4099 12.1599 15.8304 7.94057 15.8304C3.72122 15.8304 0.300781 12.4099 0.300781 8.19057C0.300781 3.97122 3.72122 0.550781 7.94057 0.550781C12.1599 0.550781 15.5804 3.97122 15.5804 8.19057ZM7.05688 12.2358L12.7251 6.56754C12.9176 6.37507 12.9176 6.06298 12.7251 5.8705L12.0281 5.17347C11.8356 4.98096 11.5235 4.98096 11.331 5.17347L6.70834 9.79609L4.55013 7.63788C4.35766 7.44541 4.04557 7.44541 3.85307 7.63788L3.15603 8.33492C2.96355 8.52739 2.96355 8.83949 3.15603 9.03196L6.35981 12.2357C6.55231 12.4282 6.86437 12.4282 7.05688 12.2358Z",
    fill: "#917AFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetick);
export default __webpack_public_path__ + "static/media/bluetick.c5e683c6ead51786911ac4dc7201d82a.svg";
export { ForwardRef as ReactComponent };